export const getOptimizeManifest = async (optimizeConfig) => {
  const optimizeData = await getOptimizeData(
    optimizeConfig,
    `/api/v1/manifest?preview=1${
      optimizeConfig?.optimizeProjectId
        ? `&projectId=${encodeURIComponent(optimizeConfig?.optimizeProjectId ?? '')}`
        : ''
    }`
  );

  if (optimizeData.result.error) {
    return optimizeData.result;
  }

  if (optimizeData.result.site) {
    return {
      result: optimizeData.result.site,
      error: null,
    };
  }

  return {
    error: new Error('getOptimizeManifest: Unexpected JSON format'),
  };
};

export const getOptimizeEnrichments = async (optimizeConfig) => {
  const optimizeData = await getOptimizeData(
    optimizeConfig,
    `/api/v1/enrichments${
      optimizeConfig?.optimizeProjectId
        ? `?projectId=${encodeURIComponent(optimizeConfig?.optimizeProjectId ?? '')}`
        : ''
    }`
  );

  if (optimizeData.result.error) {
    return optimizeData.result;
  }

  if (optimizeData.result.enrichments) {
    return {
      result: optimizeData.result.enrichments,
      error: null,
    };
  }

  return {
    error: new Error('getOptimizeEnrichments: Unexpected JSON format'),
  };
};

const getOptimizeData = async (optimizeConfig, relativeUrl) => {
  if (!optimizeConfig?.optimizeApiKey || !optimizeConfig?.optimizeApiHost) {
    return {
      result: null,
      error: new Error('Connection to Uniform Optimize is not configured.'),
    };
  }

  try {
    const res = await fetch(`${optimizeConfig.optimizeApiHost}${relativeUrl}`, {
      method: 'get',
      headers: {
        'x-api-key': optimizeConfig.optimizeApiKey,
      },
    });

    if (res.status === 400) {
      return {
        result: null,
        error: new Error('Uniform Optimize did not recognize the API key. Please check your configuration.'),
      };
    }

    const data = await res.json();

    return {
      result: data,
      error: null,
    };
  } catch (e) {
    return {
      error: e,
    };
  }
};

export const validateOptimizeConfig = (optimizeConfig) => {
  if (!optimizeConfig) {
    return {
      valid: false,
      error: new Error('optimizeConfig was not defined.'),
    };
  }

  if (!optimizeConfig.optimizeApiHost) {
    return {
      valid: false,
      error: new Error('optimizeApiHost was not defined.'),
    };
  }

  if (!optimizeConfig.optimizeApiKey) {
    return {
      valid: false,
      error: new Error('optimizeApiKey was not defined.'),
    };
  }

  return {
    valid: true,
  };
};
